var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.model)?[_c('vk-icon',{attrs:{"icon":_vm.model}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }